import {
  getSettings,
  createSettings,
  updateSettings,
  deleteSettings,
  deleteSettingsSkill,
  createOrUpdateSettings, // Import the new mutation
} from 'utils/queries/settings';

export const settingsEndpoints = (build) => ({
  getSettings: build.query({
    query: (userId) => ({
      method: 'POST',
      body: JSON.stringify({
        query: getSettings,
        variables: { userId },
      }),
    }),
    transformResponse: (response) => response.data.getSettings,
  }),
  createSettings: build.mutation({
    query: (input) => ({
      method: 'POST',
      body: JSON.stringify({
        query: createSettings,
        variables: { input },
      }),
    }),
    transformResponse: (response) => response.data.createSettings,
  }),
  updateSettings: build.mutation({
    query: ({ userId, input }) => ({
      method: 'POST',
      body: JSON.stringify({
        query: updateSettings,
        variables: { userId, input },
      }),
    }),
    transformResponse: (response) => response.data.updateSettings,
  }),
  createOrUpdateSettings: build.mutation({
    // Add the new mutation
    query: ({ userId, input }) => ({
      method: 'POST',
      body: JSON.stringify({
        query: createOrUpdateSettings,
        variables: { userId, input },
      }),
    }),
    transformResponse: (response) => response.data.createOrUpdateSettings,
  }),
  deleteSettings: build.mutation({
    query: (userId) => ({
      method: 'POST',
      body: JSON.stringify({
        query: deleteSettings,
        variables: { userId },
      }),
    }),
    transformResponse: (response) => response.data.deleteSettings,
  }),
  deleteSettingsSkill: build.mutation({
    query: (userId) => ({
      method: 'POST',
      body: JSON.stringify({
        query: deleteSettingsSkill,
        variables: { userId },
      }),
    }),
    transformResponse: (response) => response.data.deleteSettingsSkill,
  }),
});
